import { render, staticRenderFns } from "./itemComponent.vue?vue&type=template&id=4adcaeb7&scoped=true"
import script from "./itemComponent.vue?vue&type=script&lang=js"
export * from "./itemComponent.vue?vue&type=script&lang=js"
import style0 from "./itemComponent.vue?vue&type=style&index=0&id=4adcaeb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adcaeb7",
  null
  
)

export default component.exports